<template>
  <div class="teilnahmepass-main-container">
    <div class="teilnahmepass" :style="{backgroundImage: 'url(' + background + ')'}">
      <h2 v-if="islanguagede">Teilnahmepass</h2>
      <h2 v-if="islanguagepl">Karta uczestnika</h2>
      <h2 v-if="islanguagecz">Účastnický průkaz</h2>

      <div class="input">
        <label v-if="islanguagede">Stempel eintragen:</label>
        <label v-if="islanguagepl">Zarejestruj pieczątkę:</label>
        <label v-if="islanguagecz">Otisknout razítko:</label>

        <br>
        <input id="stempelstellencode" type="text" placeholder="4KPL">
        <button v-if="islanguagede" type="button" class="button" @click="submitform">Absenden</button>
        <button v-if="islanguagepl" type="button" class="button" @click="submitform">Zarejestruj pieczątkę</button>
        <button v-if="islanguagecz" type="button" class="button" @click="submitform">Otisknout razítko</button>
      </div>
    </div>

    <div ref="stempelstellencontainer" class="stempelstellen-container" />
    <div v-if="showgewinnspielformcontainer" class="gewinnspielcontainer">
      <a v-if="islanguagede && !showSuccessMessage" class="button" @click="showgewinnspielform = !showgewinnspielform">Am Gewinnspiel teilnehmen</a>
      <a v-if="islanguagepl && !showSuccessMessage" class="button" @click="showgewinnspielform = !showgewinnspielform">Udział w loterii</a>
      <a v-if="islanguagecz && !showSuccessMessage" class="button" @click="showgewinnspielform = !showgewinnspielform">Zúčastnit se soutěže</a>

      <div v-if="showSuccessMessage" class="success-message">
        <h2 v-if="islanguagede">{{ texte.de.teilnahmegewinnspielerfolgreich }}</h2>
        <h2 v-if="islanguagepl">{{ texte.pl.teilnahmegewinnspielerfolgreich }}</h2>
        <h2 v-if="islanguagecz">{{ texte.cz.teilnahmegewinnspielerfolgreich }}</h2>
      </div>

      <div v-if="showgewinnspielform" class="gewinnspielformcontainer">
        <h2 v-if="islanguagede">Glückwunsch - Sie haben 3 Stempel gesammelt! Nun können Sie mit etwas Glück, neben einem Fahrrad als Hauptgewinn, tolle Sachpreise bei unserer Tombola gewinnen!</h2>
        <h2 v-if="islanguagepl">Gratulacje – zebrałeś/aś 3 pieczątki! Teraz, przy odrobinie szczęścia, możesz wygrać w naszej loterii wspaniałe nagrody. Nagrodą główną jest rower!</h2>
        <h2 v-if="islanguagecz">Blahopřejeme – nasbírali jste 3 razítka! Nyní můžete v naší tombole s trochou štěstí vyhrát hlavní cenu – jízdní kolo, nebo další skvělé věcné ceny!</h2>

        <p v-if="islanguagede">
          Um an dem Gewinnspiel teilnehmen zu können müssen Sie nur noch kurz ein paar Angaben machen und schon nehmen Sie an der Verlosung teil.
          <br>
          <br>
          Achten Sie darauf dass Sie eine ausreichende Internetverbindung mit Ihrem mobilen Gerät besitzen.
        </p>
        <p v-if="islanguagepl">
          Aby wziąć udział w loterii, wystarczy podać kilka informacji.
          <br>
          <br>
          Państwa urządzenie mobilne musi mieć dobre połączenie z Internetem.
        </p>
        <p v-if="islanguagecz">
          Pro účast na soutěži musíte vyplnit několik málo údajů a již se budete moci účastnit slosování.
          <br>
          <br>
          Dbejte na to, aby Váš mobilní telefon měl dostatečné připojení k internetu.
        </p>

        <form ref="formgewinnspiel">
          <div class="form-item">
            <label v-if="islanguagede">Anrede*</label>
            <label v-if="islanguagepl">Anrede*</label>
            <label v-if="islanguagecz">Oslovení*</label>

            <select v-model="formgewinnspiel.anrede" required>
              <option v-if="islanguagede">Herr</option>
              <option v-if="islanguagede">Frau</option>
              <option v-if="islanguagepl">Pan</option>
              <option v-if="islanguagepl">Pani</option>
              <option v-if="islanguagecz">Pan</option>
              <option v-if="islanguagecz">Paní</option>
            </select>
          </div>

          <div class="form-item">
            <label v-if="islanguagede">Vorname*</label>
            <label v-if="islanguagepl">Imię*</label>
            <label v-if="islanguagecz">Jméno*</label>
            <input v-model="formgewinnspiel.vorname" type="text" required>
          </div>

          <div class="form-item">
            <label v-if="islanguagede">Nachname*</label>
            <label v-if="islanguagepl">Nazwisko*</label>
            <label v-if="islanguagecz">Příjmení*</label>
            <input v-model="formgewinnspiel.nachname" type="text" required>
          </div>

          <div class="form-item">
            <label v-if="islanguagede">Straße / Hausnummer*</label>
            <label v-if="islanguagepl">Ulica / nr domu*</label>
            <label v-if="islanguagecz">Ulice / č.p.*</label>
            <input v-model="formgewinnspiel.strasse" type="text" class="w70 margin-right" required>
            <input v-model="formgewinnspiel.hausnummer" type="text" class="w30 margin-left" required>
          </div>

          <div class="form-item">
            <label v-if="islanguagede">PLZ / Ort*</label>
            <label v-if="islanguagepl">Kod pocztowy / miejscowość*</label>
            <label v-if="islanguagecz">PSČ / obec*</label>
            <input v-model="formgewinnspiel.plz" type="text" class="w30 margin-right" required>
            <input v-model="formgewinnspiel.ort" type="text" class="w70 margin-left" required>
          </div>

          <div class="form-item">
            <label v-if="islanguagede">Land*</label>
            <label v-if="islanguagepl">Kraj*</label>
            <label v-if="islanguagecz">Země*</label>
            <input v-model="formgewinnspiel.land" type="text" required>
          </div>

          <div class="form-item">
            <label v-if="islanguagede">Alter*</label>
            <label v-if="islanguagepl">Wiek*</label>
            <label v-if="islanguagecz">Věk*</label>
            <input v-model="formgewinnspiel.alter" type="text" required>
          </div>

          <div class="form-item datenschutz">
            <input id="ds" v-model="formgewinnspiel.datenschutz" type="checkbox" value="accepted" required>
            <label v-if="islanguagede" for="ds">Ich habe die <a href="/#/ds" target="_blank">Datenschutzerklärung</a> zur Kenntnis genommen. Ich stimme zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden.</label>
            <label v-if="islanguagepl" for="ds">Zapoznałem/am się z <a href="/#/ds" target="_blank">polityką prywatności</a>. Wyrażam zgodę na gromadzenie i przechowywanie moich danych i informacji w formie elektronicznej w celu udzielenia odpowiedzi na moje zgłoszenie.</label>
            <label v-if="islanguagecz" for="ds">Beru na vědomí <a href="/#/ds" target="_blank">prohlášení o osobních údajích</a>. Souhlasím s tím, že moje údaje a data k zodpovězení mé poptávky budou elektronicky zpracovány a uchovány.</label>
          </div>

          <div class="form-item">
            <a v-if="islanguagede" class="button" @click="submitformgewinnspiel">Am Gewinnspiel teilnehmen</a>
            <a v-if="islanguagepl" class="button" @click="submitformgewinnspiel">Udział w loterii</a>
            <a v-if="islanguagecz" class="button" @click="submitformgewinnspiel">Zúčastnit se soutěže</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Teilnahmepass',
  props: {
    bgimg: String,
    points: Array,
  },
  data: function () {
    return {
      showgewinnspielformcontainer: false,
      showgewinnspielform: false,
      showSuccessMessage: false,
      texte: {
        de: {
          codeungueltig: 'Bitte einen gültigen Stempelstellencode eingeben.',
          codeschoneingetragen: 'Dieser Stempelstellencode wurde schon eingetragen!',
          codegespeichert: 'Die eingegebene Stempelstelle wurde gespeichert.',
          teilnahmegewinnspielerfolgreich: 'Danke für Ihre Teilnahme an der diesjährigen Sternradfahrt. Ihr Teilnahmepass wurde offiziell eingereicht.',
        },
        pl: {
          codeungueltig: 'Podaj ważny kod punktu pieczątkowego.',
          codeschoneingetragen: 'Ten kod punktu pieczątkowego został już podany.',
          codegespeichert: 'Podany punkt pieczątkowy został zapisany.',
          teilnahmegewinnspielerfolgreich: 'Dziękujemy za udział w tegorocznym Star Cycle Tour. Twój formularz zgłoszeniowy został oficjalnie wysłany.',
        },
        cz: {
          codeungueltig: 'Prosím zadejte platný kód kontrolního stanoviště.',
          codeschoneingetragen: 'Tento kód kontrolního stanoviště byl již zadán.',
          codegespeichert: 'Zadané kontrolní stanoviště bylo uloženo.',
          teilnahmegewinnspielerfolgreich: 'Děkujeme vám za účast na letošní Star Cycle Tour. Vaše přihláška byla oficiálně odeslána.',
        },
      },
      formgewinnspiel: {
        anrede: '',
        vorname: '',
        nachname: '',
        strasse: '',
        hausnummer: '',
        plz: '',
        ort: '',
        land: '',
        alter: '',
        datenschutz: '',
      },
    }
  },
  computed: {
    language: function () {
      return this.$root.$i18n.locale
    },
    islanguagede: function () {
      return (this.language == 'de')
    },
    islanguagepl: function () {
      return (this.language == 'pl')
    },
    islanguagecz: function () {
      return (this.language == 'cz')
    },
    background () {
      return require('../assets/stempelstellen-bg.jpg')
    },
  },
  created() {
    //this.createhtmlforstempelstellen()
  },
  mounted() {
    this.createhtmlforstempelstellen()
  },
  methods: {
    getpointdetailstocode(code) {
      for(var i=0; i<this.points.length; i++) {
        if(this.points[i]['alpha_code'].toLowerCase() == code) {
          return this.points[i]
        }
      }
      return false
    },
    createhtmlforstempelstellen() {
      let html = ''
      var i=0
      for(i; i<this.$root.codelist.length; i++) {
        let curPointDetails = this.getpointdetailstocode(this.$root.codelist[i].toLowerCase())
        let innerHtml = ''
        console.log('curPointDetails: ' + curPointDetails)
        if(curPointDetails != false) {
          innerHtml = '<div class="item"><span class="top">' + this.$root.codelist[i].toUpperCase() + '</span><span class="bottom">' + curPointDetails.de.Titel + '</span></div>'
        }

        html+=innerHtml

        if(curPointDetails.typ_ziel == '1' && this.$root.codelist.length >= 3) {
          this.showgewinnspielformcontainer = true
        }
      }

      if(html.length > 0) {
        html = '<h2>Ihre Stempelstellen</h2>' + html
      }

      this.$refs.stempelstellencontainer.innerHTML = html
    },
    isvalidcode(code) {
      for(var i=0; i<this.points.length; i++) {
        if(this.points[i]['alpha_code'].toLowerCase() == code) return true
      }
      return false
    },
    existcodeinlocalstorage(code) {
      console.log('existcodeinlocalstorage')
      for(var i=0; i<this.$root.codelist.length; i++) {
        console.log(this.$root.codelist[i])
        if(this.$root.codelist[i].toLowerCase() == code) return true
      }
      return false
    },
    submitform() {
      let code = document.getElementById('stempelstellencode').value

      if(code.trim().length == 0 || !this.isvalidcode(code.trim().toLowerCase())) {
        alert(this.texte[this.language].codeungueltig)
        return false
      }
      code = code.trim().toLowerCase()

      if(this.existcodeinlocalstorage(code)) {
        alert(this.texte[this.language].codeschoneingetragen)
        return false
      }

      //code in local storage schreiben
      this.$root.codelist.push(code)
      console.log(this.$root.codelist)

      //code in DB speichern wenn es schon einen Teilnehmereintrag gibt
      if(localStorage.getItem('hash_id') != '' && localStorage.getItem('hash_id') != undefined) {
        var params = new URLSearchParams()
        params.append('hash_id', localStorage.getItem('hash_id'))
        params.append('code', code)

        axios.post( process.env.VUE_APP_API_ENDPOINT + 'teilnehmer/syncupdate', params)
          .then(function (response) {
            console.log(response)
            console.log(response.data.success)

            if(response.data.success == true) {
              alert(response.data.msg)
              this.showgewinnspielformcontainer = false
              this.showgewinnspielform = false
            } else {
              alert('Anfrage konnte nicht bearbeitet werden')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }

      //code list aktualisieren
      this.createhtmlforstempelstellen()


      //Details of Location By Code
      let curPointDetails = this.getpointdetailstocode(code.toLowerCase())
      window._paq.push(['trackEvent', 'Stempelstelle', 'Stempelstelle eintragen', curPointDetails.de.Titel, '1'])

      alert(this.texte[this.language].codegespeichert)
    },
    submitformgewinnspieltodb() {
      var _this = this
      let codelist = this.$root.codelist
      if(codelist.length == 0) {
        console.log('submitformgewinnspieltodb: Konnte nicht synchronisiert werden. Keine Daten vorhanden.')
        return false
      }

      let formdata = this.formgewinnspiel
      var params = new URLSearchParams()
      params.append('codelist', codelist.toString())
      params.append('formdata', JSON.stringify(formdata))
      params.append('hash_id', localStorage.getItem('hash_id'))

      axios.post( process.env.VUE_APP_API_ENDPOINT + 'teilnehmer/sync', params)
        .then(function (response) {
          console.log(response)
          console.log(response.data.success)
          console.log(response.data.data.teilnehmerid)

          if(response.data.success == true) {
            localStorage.setItem('hash_id', response.data.data.teilnehmerhash)

            window._paq.push(['trackEvent', 'Gewinnspiel', 'Gewinnspiel Teilnahme', 'Formular abgesendet', '1'])

            _this.showgewinnspielform = false
            _this.showSuccessMessage = true
          } else {
            alert('Anfrage konnte nicht bearbeitet werden')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    submitformgewinnspiel() {
      let form = this.$refs.formgewinnspiel

      if(!form.reportValidity()) {
        return false
      }

      this.submitformgewinnspieltodb()

    },
  },
}
</script>

<style scoped lang="scss">
.teilnahmepass {
  text-align: left;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 40px;
  box-sizing: border-box;
  margin-top: 40px;

  @media screen and (max-width: 480px) {
    padding: 20px;
  }

  h2 {
    font-weight: bold;
    color: white;
    background-color: rgba(239, 125, 0, 0.8);
    padding: 10px;
    box-sizing: border-box;
    display: inline-block;
    margin-bottom: 20px;
  }
  .input {
    margin-top: 50px;
    box-sizing: border-box;
    background-color: rgba(255,255,255,0.8);
    padding: 20px 10px;
    display: block;
    width: 300px;

    @media screen and (max-width: 480px) {
      margin-top: 30px;width: auto;
    }

    label {
      font-weight: bold;
    }
    input[type="text"] {
      border: 0;
      box-sizing: border-box;
      padding: 10px;
      margin-top: 10px;
      width: 100%;
      color: rgba(239, 125, 0, 1);
      font-weight: bold;
    }
    button {
      background-color: rgba(239, 125, 0, 1);
      text-transform: uppercase;
      padding: 10px 30px;
      box-sizing: border-box;
      color: white;
      font-weight: bold;
      margin-top: 20px;
      border: 0;
    }
  }
}
.stempelstellen-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 30px;



  ::v-deep h2 {
    width: 100%;
  }

  ::v-deep .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px;

    width: calc(33.3333333333% - 20px);

    padding: 20px;
    box-sizing: border-box;
    color: rgba(239, 125, 0, 1);
    border: 2px solid rgba(239, 125, 0, 1);
    border-radius: 5px;

    @media screen and (max-width: 768px) {
      width: calc(50% - 20px);
    }
    @media screen and (max-width: 480px) {
      width: calc(100%);
    }

    .top {
      font-size: 25px;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center;
    }
    .bottom {
      font-size: 18px;
      font-weight: normal;
      text-transform: none;
      text-align: center;
    }
  }
}
.success-message {
  margin-top: 40px;
  padding: 30px;
  background-color: #4CAF50;
  color: white;
  border-radius: 5px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;

  h2 {
    margin: 0;
    font-weight: bold;
    font-size: 24px;
  }
}

.gewinnspielformcontainer {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .form-item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 100%;

    label {
      margin: 10px 0;
      width: 100%;
      font-weight: bold;
    }

    input[type="text"], select {
      padding: 15px 30px;
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      border: 1px solid orange;
      border-radius: 5px;

      &.w70 {
        width: 70%;

        &.margin-left {
          margin-left: 5px;
          width: calc(70% - 5px);
        }
        &.margin-right {
          margin-right: 5px;
          width: calc(70% - 5px);
        }
      }
      &.w30 {
        width: 30%;

        &.margin-left {
          margin-left: 5px;
          width: calc(30% - 5px);
        }
        &.margin-right {
          margin-right: 5px;
          width: calc(30% - 5px);
        }
      }
    }
  }
}
</style>
